<template>
  <div>
    <div class="lg-section flex flex-wrap pb3 sm-px3 ti-page-start py2">
      <div class="sm-col sm-col-12 md-col-4 pr2">
        <div class="pb2">
          <div class="flex items-baseline">
            <h1 class="ti-h2 flex-auto">Reports & Insights</h1>
          </div>
          <div class="ti-under"></div>
        </div>
        <div v-if="['none', 'all'].indexOf($store.state.accessible)==-1" class="mb1 mr2 right">
          <span class="link-action ml1" @click="accessibleFilters()">accessible by me</span>
        </div>
        <FilterTerm @updateTerms="updateTerms" :initTerms="$store.state.terms" />
        <div class="my2">
          <SideFilterGroup allLabel="All Content Types"
                           headerClass="ti-tag-type"
                           :filters="$store.state.filters.types"
                           :refMap="$store.state.refMap.type"
                           :defs="$store.state.defs"
                           :counts="null"
                           :alwaysExpanded="true"
                           @optClick="toggleFilter('types', $event)"
                           >
          </SideFilterGroup>
        </div>
        <div class="my2">
          <SideFilterGroup allLabel="All Technologies"
                           headerClass="ti-tag-technology"
                           :filters="$store.state.filters.technologies"
                           :refMap="$store.state.refMap.technology"
                           :counts="null"
                           @optClick="toggleFilter('technologies', $event)"
                           :defs="TechDef"
                           >
          </SideFilterGroup>
        </div>
        <div class="my2">
          <SideFilterGroup allLabel="All ISIC Verticals"
                           headerClass="ti-tag-sector"
                           :filters="$store.state.filters.sectors"
                           :refMap="$store.state.refMap.sector"
                           :counts="null"
                           @optClick="toggleFilter('sectors', $event)"
                           >
          </SideFilterGroup>
        </div>
        <!-- 2021-10-02 disabled as reports not really specifying regions yet -->
        <!-- <div class="my2"> -->
        <!--   <SideFilterGroup allLabel="All Regions" -->
        <!--                    headerClass="ti-tag-region" -->
        <!--                    :filters="$store.state.filters.regions" -->
        <!--                    :refMap="$store.state.refMap.region" -->
        <!--                    :counts="null" -->
        <!--                    @optClick="toggleFilter('regions', $event)" -->
        <!--                    > -->
        <!--   </SideFilterGroup> -->
        <!-- </div> -->
      </div>

      <div class="sm-col sm-col-12 md-col-8" v-if="refreshing===true">
        <div class="ti-p">Loading ...</div>
      </div>
      <div class="sm-col sm-col-12 md-col-8" v-else>
        <div class="ti-page" v-html="$store.state.intro"
             style="font-size:14px;">
        </div>
        <div v-if="$store.state.reports.length == 0" class="ti-p">
          &nbsp;&nbsp;No matches
        </div>
        <div else>
          <p class="ml1 mb2"><strong>{{$store.state.page.count}}</strong>
            Results<span class="px1">-</span>ordered by
            <span>
              <input type="radio" id="orderDate" :disabled="$store.state.terms.length==0"
                     value="date" v-model="$store.state.orderBy"
                     @change="updateOrder('date')">
              <label for="orderDate">Date</label>

              <template v-if="$store.state.terms.length != 0">
                <input class="ml3" type="radio" id="orderRelevance"
                       value="relevance" v-model="$store.state.orderBy"
                       @change="updateOrder('relevance')">
                <label for="orderRelevance">Relevance</label>
              </template>
            </span>
          </p>
        </div>
        <Paginate :totalPages="$store.state.page.totalPages"
                  :currentPage="$store.state.page.currentPage"
                  @goPage="goPage">
        </Paginate>
        <div v-for="report in $store.state.reports" :key="report.id"
             class="report-card mt1 mb2 pb1" :class="{'report-featured': report.featured}">
          <router-link class="link-wrapper mt1"
                       :to="{name: 'report-detail',
                            params: {slug:report.slug} }">
            <ReportCard :report="report" />
          </router-link>

          <div v-if="report.report_type == 'Webinar'" class="right-align px3">
            <router-link tag="button" class="btn btn-primary btn-small"
                         @click.native.prevent
                         :to="{name: 'report-detail',
                              params: {slug:report.slug} }">
              View
            </router-link>
          </div>
          <template v-else-if="report.has_doc">
            <form method="post"
                  @submit="preDownload(report.slug)"
                  :action="`/research/report-download/${report.slug}`">
              <input v-for="question in (report.download_questions || [])"
                     :key="question.key"
                     type="hidden"
                     :name="`answer_${question.key}`"
                     :value="selectedAnswers[question.key] || ''">
              <div class="right-align px3">
                <template v-if="report.can_download">

                  <!-- Vendor Insight should be downloadable straight because user with
                       access to peer-benchmar should see they have a better report -->
                  <!-- 2023-06-10 UPDATE: remove this feature. just one report is being created. -->
                  <!-- <div v-if="report.report_type == 'Vendor_Insight'"> -->
                  <!--   <div class="right-align"> -->
                  <!--     <router-link tag="button" class="btn btn-primary btn-small" -->
                  <!--                  @click.native.prevent -->
                  <!--                  :to="{name: 'report-detail', -->
                  <!--                       params: {slug:report.slug} }"> -->
                  <!--       Download Options -->
                  <!--     </router-link> -->
                  <!--   </div> -->
                  <!-- </div> -->
                  <!-- <template v-else> -->
                    <button class="btn btn-primary btn-small"
                            @click="onDownloadClick($event, report)">
                      Download report
                    </button>
                  <!-- </template> -->
                </template>
                <template v-else>
                  <input type="button" class="btn btn-primary btn-small"
                         disabled value="Download report"/>
                  <div style="margin-top:4px;">
                    <span v-if="report.white_paper">
                      <a href="/login" class="ti-link">Log in</a> or
                      <a href="/signup" class="ti-link">sign up</a>
                      to a free ESSENTIAL subscription to access.
                    </span>
                    <span v-else-if="report.essential_read">
                      <a href="/login" class="ti-link">Log in</a> or
                      <a href="/signup" class="ti-link">sign up</a>
                      to a free ESSENTIAL subscription to access.
                    </span>
                    <!-- TODO: message for user group -->
                    <!-- <span v-else-if="report.essential_read"> -->
                    <!--   <a href="/login" class="ti-link">Log in</a> or -->
                    <!--   <a href="/signup" class="ti-link">sign up</a> -->
                    <!--   to a free ESSENTIAL subscription to access. -->
                    <!-- </span> -->
                    <span v-else>
                      <a class="ti-link pr2" style="font-weight:normal;"
                         href="/research/overview">
                        View offerings
                      </a>
                    </span>
                  </div>
                </template>
              </div>
            </form>
          </template>
        </div>  <!-- card -->

        <div class="right-align">
          <Paginate :totalPages="$store.state.page.totalPages"
                    :currentPage="$store.state.page.currentPage"
                    @goPage="goPage">
          </Paginate>
        </div>
      </div>
    </div>

    <ReportQuestionsModal v-if="showQuestionsModal"
                          :questions="pendingQuestions"
                          @confirm="onQuestionsConfirm"
                          @close="showQuestionsModal = false" />
  </div>
</template>

<script>
import TechDef from '@/tech';
import FilterTerm from '@/components/FilterTerm.vue';
import Paginate from '@/components/Paginate.vue';
import SideFilterGroup from '@/components/SideFilterGroup.vue';
import ReportCard from '@/components/ReportCard.vue';
import ReportQuestionsModal from './ReportQuestionsModal.vue';

/* global gtag */

export default {
  name: 'ReportList',
  components: {
    FilterTerm,
    Paginate,
    SideFilterGroup,
    ReportCard,
    ReportQuestionsModal,
  },
  data() {
    return {
      TechDef,
      loading: true,
      refreshing: true,

      showQuestionsModal: false,
      pendingForm: null,
      pendingQuestions: [],
      selectedAnswers: {},
    };
  },

  computed: {
  },

  created() {
    // set filters based on url
    // Note: for first load, reports were already filtered by server
    // 22-07-19 UserGroup removed
    // if (this.$route.query.usergroup === '1') {
    //   const current = Boolean(this.$store.state.filters.types.ti_group);
    //   if (current !== true) {
    //     this.$store.commit('toggleFilter', { cat: 'types', id: 'ti_group' });
    //   }
    // }

    if (this.$store.state.reports === null || this.$store.state.needReadURLQuery) {
      // set filter values based on URL query parameters
      const processURLFilter = this.readQueryFilters();
      this.$store.state.needReadURLQuery = false;
      if (processURLFilter || this.$store.state.reports === null) {
        this.getReports(1, true, 'load');
      } else {
        this.refreshing = false;
      }
    } else {
      // navigating back from detail page...
      this.refreshing = false;
      this.setUrlQuery();
    }

    // SEO is displayed on list page (make sure not hidden)
    const seo = document.getElementById('report-bottom');
    if (seo) {
      seo.style.display = '';
    }
  },

  mounted() {
    document.title = 'Reports & Insights';
  },

  methods: {
    /* tc: track control, which action an user performed */
    getReports(page = 1, getMeta = false, tc = null) {
      // get list of studies
      this.refreshing = true;
      const postData = {
        page,
        getMeta,
        filters: this.$store.state.filters,
        terms: this.$store.state.terms,
        orderBy: this.$store.state.orderBy,
      };
      const params = { tc };
      if (this.$store.state.terms) {
        params.q = [...this.$store.state.terms];
        if (page) {
          params.page = page;
        }
      }
      this.$axios.post('/api/reports', postData, { params })
        .then((res) => {
          if (getMeta) {
            this.$store.commit('setIntro', res.data.intro);
            this.$store.commit('setAccessible', res.data.accessible);
            this.$store.commit('setTiGroup', res.data.ti_group);
            this.$store.commit('setEnhanced', res.data.enhanced);
          }
          this.$store.commit('initReports', res.data.reports);
          this.$store.commit('setPage', res.data.page);
          this.refreshing = false;
        });
    },

    goPage(pageIndex, navKind) {
      this.getReports(pageIndex, false, 'page');
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      if (navKind !== null) {
        gtag('event', 'report_page', {
          event_category: 'report',
          event_label: navKind,
          value: pageIndex,
        });
      }
    },

    updateTerms(terms) {
      this.$store.commit('setTerms', terms);
      gtag('event', 'report_filter', {
        event_category: 'report',
        event_label: 'term',
      });
      this.$nextTick()
        .then(() => {
          this.getReports(1, false, 'term');
        });
    },

    updateOrder(value) {
      this.$store.commit('setOrder', value);
      gtag('event', 'report_filter', {
        event_category: 'report',
        event_label: 'order',
      });
      this.$nextTick()
        .then(() => {
          this.getReports(1, false, 'sort');
        });
    },

    // Update URL with query parameters to match filter selection.
    // This is called whenever a filter value is toggled
    setUrlQuery() {
      const query = {
        type: Object.keys(this.$store.state.filters.types),
        tech: Object.keys(this.$store.state.filters.technologies),
      };
      // catch() to ignore NavigationDuplicated error
      this.$router.replace({ name: 'report-list', query }).catch(() => {});
    },

    // set filter values based on URL query parameters - opposite of setUrlQuery
    readQueryFilters() {
      let hasFilter = false;
      if ('type' in this.$route.query) {
        hasFilter = true;
        const qtype = this.$route.query.type;
        const types = Array.isArray(qtype) ? qtype : [qtype];
        for (const param of types) {
          this.$store.commit('toggleFilter', { cat: 'types', id: param });
        }
      }
      if ('tech' in this.$route.query) {
        hasFilter = true;
        const qtech = this.$route.query.tech;
        const techs = Array.isArray(qtech) ? qtech : [qtech];
        for (const param of techs) {
          this.$store.commit('toggleFilter', { cat: 'technologies', id: param });
        }
      }
      return hasFilter;
    },


    toggleFilter(cat, id) {
      this.$store.commit('toggleFilter', { cat, id });
      gtag('event', 'report_filter', {
        event_category: 'report',
        event_label: cat,
      });
      this.setUrlQuery();
      this.$nextTick()
        .then(() => {
          this.getReports(1, false, 'filter');
        });
    },

    // handle the "accessible by me" click event
    accessibleFilters() {
      gtag('event', 'report_filter', {
        event_category: 'report',
        event_label: 'accessible',
      });

      const accessible = this.$store.state.accessible;

      if (accessible === 'all') {
        this.$store.commit('toggleFilter', { cat: 'types', id: null });
        this.$nextTick()
          .then(() => {
            this.getReports(1, false, 'access');
          });
        return;
      }

      function maybeToggle(prop, desired) {
        const current = Boolean(this.$store.state.filters.types[prop]);
        if (current !== desired) {
          this.$store.commit('toggleFilter', { cat: 'types', id: prop });
        }
      }
      const white = (accessible === 'white' || accessible === 'essential');
      maybeToggle.call(this, 'white_paper', white);
      maybeToggle.call(this, 'essential_read', accessible === 'essential');
      // maybeToggle.call(this, 'ti_group', this.$store.state.tiGroup); // removed

      // When user is Enhanced, all Tech_Insights are retrieved on Tech_Insights.
      // The code below would not work all because it would force an AND filter of
      // report types & accessibility flags.
      // const enhanced = this.$store.state.enhanced;
      // maybeToggle.call(this, 'Tech_Insights', enhanced);


      // for non-prime, report kind is not modified, but for prime we enable all but
      // peer benchmarking.
      if (accessible === 'prime') {
        maybeToggle.call(this, 'Tech_Insights', true);
        maybeToggle.call(this, 'Vendor_Insight', true);
        maybeToggle.call(this, 'Case_Study_Insight', true);
        maybeToggle.call(this, 'Forecast_Insight', true);
        maybeToggle.call(this, 'Key_Topic_Insight', true);
        maybeToggle.call(this, 'Webinar', true);
        maybeToggle.call(this, 'Peer_Benchmarking', false);
      }
      this.$nextTick()
        .then(() => {
          this.getReports(1, false, 'access');
        });
    },

    preDownload(slug) {
      // send GA event
      gtag('event', 'report_download', {
        event_category: 'report',
        event_label: slug,
        value: 0, // 0 means download from list page
      });
    },
    onDownloadClick(event, report) {
      const questions = report.download_questions || [];
      if (questions.length === 0) return; // no question -> native submit
      event.preventDefault();
      this.pendingForm = event.target.form;
      this.pendingQuestions = questions;
      this.selectedAnswers = {};
      this.showQuestionsModal = true;
    },
    async onQuestionsConfirm(answers) {
      this.selectedAnswers = { ...answers };
      this.showQuestionsModal = false;
      await this.$nextTick();
      // requestSubmit (not submit) so the form's @submit listener fires
      // and the existing GA event is still recorded.
      this.pendingForm.requestSubmit();
    },
  },
};
</script>

<style>
  .link-action {
    cursor: pointer;
    font-family: Tahoma;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.04em;
    color: #9B99CB; /* purple */
    padding: 0 6px;
    border: 1px solid #9B99CB;
    border-radius: 3px;
  }

</style>
